import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./SideBySideLayout.html';
import styles from './SideBySideLayout-hashed.scss';
import angular from 'angular';


angular.module('edge.platform.widgets.side-by-side-layout', []).component('gwSideBySideLayout', {
    transclude: {
        left: 'gwLayoutLeft',
        right: 'gwLayoutRight'
    },
    template: cssUtil.hashTemplate(template, styles)
});